import MuiAccordionSummary from "@mui/material/AccordionSummary";
const AccordionSummary = MuiAccordionSummary;
export default AccordionSummary;
